import { FC, useEffect, useRef } from 'react';
import {
  NegativeFeedbackContainer,
  NegativeOption,
  NegativeTitleWrapper,
} from './NegativeFeedback.styles';
import { AllieQueryInput, AllieText } from '../../../../../components';
import { AllieCloseOutlineIcon } from '../../../../../styling/icons';
import { ReasonsOptions } from '../../ChatResponse.types';

interface NegativeOptionsProps {
  options: ReasonsOptions[];
  setHideOptions: (value: boolean) => void;
  selectedReason: number | undefined;
  handleSelectedReason: (id: number) => void;
  showInputFeedback: boolean;
  handleFeedback: (value: string) => void;
  clear: object;
  labelNegativeOptions: string;
  placeholderOtherOption?: string;
}

export const NegativeFeedback: FC<NegativeOptionsProps> = ({
  options,
  setHideOptions,
  selectedReason,
  showInputFeedback,
  labelNegativeOptions,
  placeholderOtherOption,
  handleFeedback,
  handleSelectedReason,
  clear,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [containerRef.current]);

  return (
    <NegativeFeedbackContainer ref={containerRef}>
      <NegativeTitleWrapper>
        <AllieText type="body1" color="neutral-70">
          {labelNegativeOptions}
        </AllieText>
        <AllieCloseOutlineIcon onClick={() => setHideOptions(true)} color="neutral-60" />
      </NegativeTitleWrapper>
      {options.map((reason) => (
        <NegativeOption
          selected={selectedReason === reason.id}
          onClick={() => handleSelectedReason(reason.id)}
        >
          <AllieText type="body2" color={selectedReason === reason.id ? 'white' : 'neutral-90'}>
            {reason.reason}
          </AllieText>
        </NegativeOption>
      ))}
      {showInputFeedback && (
        <AllieQueryInput
          maxlength={140}
          onSearch={handleFeedback}
          clean={clear}
          placeholder={placeholderOtherOption}
          suffixAlign="bottom"
        />
      )}
    </NegativeFeedbackContainer>
  );
};
